import React from 'react';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import {
	FlexContainer,
	Avatar,
	Title,
	AttributeName,
	AttributeValue,
	LinkedIssueCard,
} from './styled.tsx';

export const TitleSkeleton = () => (
	<FlexContainer marginBottom={gridSize * 2}>
		<Avatar />
		<Title />
	</FlexContainer>
);

const AttributesListItem = () => (
	<FlexContainer>
		<AttributeName />
		<AttributeValue />
	</FlexContainer>
);

export const AttributesListSkeleton = () => (
	<>
		<AttributesListItem />
		<AttributesListItem />
		<AttributesListItem />
		<AttributesListItem />
	</>
);

export const LinkedIssuesSkeleton = () => (
	<div>
		<LinkedIssueCard />
		<LinkedIssueCard />
	</div>
);
